import PropTypes from 'prop-types';

export default function Button(props) {
    const {className, onClick, label, type, name} = props;

    return <button type={type} onClick={onClick} key={`button-${name}`} className={className}>
        {label}
    </button>;
}

Button.propTypes = {
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
}

Button.defaultProps = {
    type: "button",
    className: "",
    name: Math.random()
}
